module.exports = __webpack_public_path__ + "static/media/KaTeX_Typewriter-Regular.6b9645af.ttf";